(() => {
  function init(root) {
    root.querySelectorAll('[data-tbs-carousel]').forEach(carousel => {
      if (carousel.dataset.tbsReady) return;
      carousel.dataset.tbsReady = 'true';
      const track = carousel.querySelector('.tbs-track');
      const slides = [...track.children];
      if (slides.length < 2) return;
      const distance = () => slides[1].offsetLeft - slides[0].offsetLeft;
      const max = () => track.scrollWidth - track.clientWidth;
      const move = direction => {
        const step = distance();
        if (direction > 0 && track.scrollLeft >= max() - 3) track.scrollTo({ left: 0, behavior: 'smooth' });
        else if (direction < 0 && track.scrollLeft <= 3) track.scrollTo({ left: max(), behavior: 'smooth' });
        else track.scrollBy({ left: direction * step, behavior: 'smooth' });
      };
      carousel.querySelector('[data-tbs-prev]').addEventListener('click', () => move(-1));
      carousel.querySelector('[data-tbs-next]').addEventListener('click', () => move(1));
      track.addEventListener('keydown', event => {
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault();
          move(event.key === 'ArrowRight' ? 1 : -1);
        }
      });
      if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        let timer;
        const stop = () => clearInterval(timer);
        const start = () => { stop(); timer = setInterval(() => move(1), 5500); };
        carousel.addEventListener('mouseenter', stop);
        carousel.addEventListener('mouseleave', start);
        carousel.addEventListener('focusin', stop);
        carousel.addEventListener('focusout', event => { if (!carousel.contains(event.relatedTarget)) start(); });
        start();
      }
    });
  }
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
